import React from "react";
import { SubjectsIntroContainer } from "./SubjectsIntro.style";
import HeadingWithIcon from "Components/landing_page/HeadingWithIcon";

// Subject Images
import CivicsLogo from "Assets/Images/Subjects/civics_logo.png";
import ForeignLanguageLogo from "Assets/Images/Subjects/foreignlanguage_logo.png";
import EnglishLogo from "Assets/Images/Subjects/english_logo.png";
import EconomicsLogo from "Assets/Images/Subjects/economics_logo.png";
import HistoryLogo from "Assets/Images/Subjects/history_logo.png";
import MathLogo from "Assets/Images/Subjects/math_logo.png";
import ScienceLogo from "Assets/Images/Subjects/science_logo.png";

// Correct sequence
const subjectImages = [
	{ image: CivicsLogo, target: "civics" },
	{ image: ScienceLogo, target: "science" },
	{ image: MathLogo, target: "math" },
	{ image: ForeignLanguageLogo, target: "foreign-language" },
	{ image: EnglishLogo, target: "english" },
	{ image: HistoryLogo, target: "history" },
	{ image: EconomicsLogo, target: "economics" },
];
const SubjectsIntro = () => {
	return (
		<SubjectsIntroContainer>
			<div className="subjectsintro_main">
				<div className="mygrid-container">
					<div className="mygrid-row">
						<div className="mygrid-col-lg-4 mygrid-col-md-12">
							<div className="subjects_intro_heading">
								<HeadingWithIcon highlight="Subjects">Our</HeadingWithIcon>
							</div>
						</div>
						<div className="mygrid-col-lg-8 mygrid-col-md-12">
							<div className="subjects_intro_text">
								<p>
									<strong>At Subjects Master</strong>, we make learning engaging, interactive, and tailored to every student. Our platform covers a wide range of core subjects,
									including Civics, Math, Science, English, Economics, Foreign Language, and History. Each subject combines standards-aligned content with hands-on, gamified
									activities designed to spark curiosity and mastery.
								</p>
								<p>
									Whether your goal is to reinforce tough concepts, prepare for tests, or inspire a love of learning, our customizable lessons and interactive games empower students
									to succeed at their own pace. With Subjects Master, every subject becomes an opportunity to explore, experiment, and excel.
								</p>
							</div>
						</div>
					</div>
					<div className="mygrid-row">
						<div className="subjects_intro_images">
							{subjectImages.map((item, index) => (
								<div
									key={index}
									className="subjects_intro_image_wrapper"
									onClick={() => {
										const el = document.getElementById(item.target);
										if (el) el.scrollIntoView({ behavior: "smooth" });
									}}
									style={{ cursor: "pointer" }}
								>
									<img src={item.image} alt={`Subject ${index + 1}`} />
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</SubjectsIntroContainer>
	);
};

export default SubjectsIntro;
